import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { serviceWorkerManager } from './lib/service-worker-manager';
import '@quiz-commerce/design-system/styles/tokens.css';
import './styles/global.css';

// Create a client for TanStack Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      staleTime: 60000, // 1 minute
    },
  },
});

// Initialize axe-core accessibility testing in development mode
if (import.meta.env.DEV) {
  import('@axe-core/react').then((axe) => {
    axe.default(React, ReactDOM, 1000);
  }).catch((error) => {
    console.error('Failed to initialize axe-core:', error);
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// Service Worker Management
// This provides additional control over PWA service worker lifecycle

// Initialize service worker based on environment configuration
const enablePWA = import.meta.env.VITE_ENABLE_PWA !== 'false';

if (enablePWA) {
  // Register service worker with automatic update handling
  serviceWorkerManager.register().catch((error) => {
    console.error('[App] Failed to register service worker:', error);
  });
} else {
  // Kill-switch: Unregister all service workers
  serviceWorkerManager.unregisterAll().catch((error) => {
    console.error('[App] Failed to unregister service workers:', error);
  });
}

